import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/desarrollo-web/tarjeta-digital/TarjetaDigitalClient.tsx");
